
// Autocompletedata · JS
// Starter lists for the autocomplete dropdowns.
// Extend these freely, or later replace with an API call
// (e.g. GET /skills/suggestions?q=htm) if the list gets large.
 
export const SKILLS_LIST = [
  'HTML', 'HTML/CSS', 'HTML5', 'CSS', 'CSS3', 'Sass', 'Tailwind CSS',
  'JavaScript', 'JavaScript (ES6+)', 'TypeScript', 'React.js', 'React Hooks',
  'Next.js', 'Vue.js', 'Angular', 'Redux', 'Context API', 'Node.js',
  'Express.js', 'Nest.js', 'PHP', 'Laravel', 'Python', 'Django', 'Flask',
  'Java', 'Spring Boot', 'C', 'C++', 'C#', '.NET', 'Ruby', 'Ruby on Rails',
  'Go', 'Rust', 'SQL', 'MySQL', 'PostgreSQL', 'MongoDB', 'Redis', 'Firebase',
  'REST API', 'RESTful API Design', 'GraphQL', 'JWT Authentication',
  'OAuth', 'Docker', 'Kubernetes', 'AWS', 'Azure', 'Google Cloud Platform',
  'Git', 'GitHub', 'CI/CD', 'Linux', 'Nginx', 'HTTP', 'HTTP server',
  'Data Structures', 'Algorithms', 'Machine Learning', 'Deep Learning',
  'Data Analysis', 'Excel', 'Power BI', 'Tableau', 'Figma', 'UI/UX Design',
  'Digital Marketing', 'SEO', 'Content Writing', 'Project Management',
  'Communication', 'Leadership', 'Team Management', 'Problem Solving',
];
 
// export const COLLEGES_LIST = [
//   'Indian Institute of Technology Bombay',
//   'Indian Institute of Technology Delhi',
//   'Indian Institute of Technology Madras',
//   'Indian Institute of Technology Kanpur',
//   'Indian Institute of Technology Kharagpur',
//   'Indian Institute of Technology Roorkee',
//   'Indian Institute of Technology Guwahati',
//   'Indian Institute of Science Bangalore',
//   'National Institute of Technology Tiruchirappalli',
//   'National Institute of Technology Surathkal',
//   'National Institute of Technology Warangal',
//   'Delhi University',
//   'Jawaharlal Nehru University',
//   'Anna University',
//   'Vellore Institute of Technology',
//   'Manipal Institute of Technology',
//   'Birla Institute of Technology and Science, Pilani',
//   'Amity University',
//   'Christ University',
//   'Symbiosis International University',
//   'Bangalore University',
//   'Osmania University',
//   'Pune University (Savitribai Phule Pune University)',
//   'Mumbai University',
//   'RV College of Engineering',
//   'PES University',
//   'PSG College of Technology',
//   'SRM Institute of Science and Technology',
//   'Lovely Professional University',
//   'Chandigarh University',
//   'Guru sudhindra degree college bhatkal'
// ];


export const COLLEGES_LIST = [
  // IITs
  'Indian Institute of Technology Bombay',
  'Indian Institute of Technology Delhi',
  'Indian Institute of Technology Madras',
  'Indian Institute of Technology Kanpur',
  'Indian Institute of Technology Kharagpur',
  'Indian Institute of Technology Roorkee',
  'Indian Institute of Technology Guwahati',
  'Indian Institute of Technology Hyderabad',
  'Indian Institute of Technology Indore',
  'Indian Institute of Technology Mandi',
  'Indian Institute of Technology Bhubaneswar',
  'Indian Institute of Technology Gandhinagar',
  'Indian Institute of Technology Ropar',
  'Indian Institute of Technology Jodhpur',
  'Indian Institute of Technology Patna',
  'Indian Institute of Technology BHU Varanasi',

  // IISc & IIITs
  'Indian Institute of Science Bangalore',
  'International Institute of Information Technology Bangalore (IIIT-B)',
  'Indian Institute of Information Technology Allahabad',
  'Indian Institute of Information Technology Hyderabad',
  'Indian Institute of Information Technology Lucknow',

  // NITs
  'National Institute of Technology Tiruchirappalli',
  'National Institute of Technology Surathkal',
  'National Institute of Technology Warangal',
  'National Institute of Technology Calicut',
  'National Institute of Technology Rourkela',
  'National Institute of Technology Kurukshetra',
  'National Institute of Technology Durgapur',
  'National Institute of Technology Silchar',
  'National Institute of Technology Hamirpur',
  'National Institute of Technology Jalandhar',

  // Universities
  'Delhi University',
  'Jawaharlal Nehru University',
  'Anna University',
  'Bangalore University',
  'University of Mysore',
  'Mangalore University',
  'Karnataka University Dharwad',
  'Kuvempu University',
  'Tumkur University',
  'Bengaluru City University',
  'Bengaluru North University',
  'Visvesvaraya Technological University (VTU)',
  'Rajiv Gandhi University of Health Sciences',
  'Osmania University',
  'Andhra University',
  'University of Hyderabad',
  'University of Calcutta',
  'University of Madras',
  'University of Mumbai',
  'Savitribai Phule Pune University',
  'Banaras Hindu University',
  'Aligarh Muslim University',
  'Jamia Millia Islamia',
  'Panjab University',
  'University of Kerala',
  'University of Calicut',
  'Mahatma Gandhi University',
  'Gujarat University',

  // Private Universities
  'Vellore Institute of Technology',
  'Manipal Institute of Technology',
  'Manipal Academy of Higher Education',
  'Birla Institute of Technology and Science, Pilani',
  'Amity University',
  'Christ University',
  'Symbiosis International University',
  'SRM Institute of Science and Technology',
  'Lovely Professional University',
  'Chandigarh University',
  'PES University',
  'REVA University',
  'Jain University',
  'Alliance University',
  'CMR University',
  'Presidency University Bengaluru',
  'Dayananda Sagar University',
  'Ramaiah University of Applied Sciences',
  'Garden City University',
  'Azim Premji University',
  'KLE Technological University',
  'Nitte Meenakshi Institute of Technology',

  // Engineering Colleges
  'RV College of Engineering',
  'BMS College of Engineering',
  'MS Ramaiah Institute of Technology',
  'Dayananda Sagar College of Engineering',
  'Bangalore Institute of Technology',
  'NIE Mysore',
  'Siddaganga Institute of Technology',
  'RNS Institute of Technology',
  'CMR Institute of Technology',
  'New Horizon College of Engineering',
  'Acharya Institute of Technology',
  'KLE Technological University',
  'SDM College of Engineering and Technology',
  'PES College of Engineering Mandya',
  'Malnad College of Engineering',
  'MVJ College of Engineering',
  'Nitte Meenakshi Institute of Technology',
  'BNM Institute of Technology',
  'AMC Engineering College',
  'Cambridge Institute of Technology',
  'Global Academy of Technology',
  'Don Bosco Institute of Technology',
  'PSG College of Technology',
  'Thiagarajar College of Engineering',
  'SSN College of Engineering',
  'Kumaraguru College of Technology',
  'Coimbatore Institute of Technology',
  'MIT World Peace University',

  // Medical Colleges
  'Bangalore Medical College and Research Institute',
  'St Johns Medical College',
  'Kasturba Medical College Manipal',
  'Kasturba Medical College Mangalore',
  'JSS Medical College',
  'Kempegowda Institute of Medical Sciences',
  'MS Ramaiah Medical College',
  'Vydehi Institute of Medical Sciences',
  'Father Muller Medical College',
  'Jawaharlal Nehru Medical College Belagavi',

  // Commerce & Arts Colleges
  'Mount Carmel College',
  'St Josephs University Bengaluru',
  'Kristu Jayanti College',
  'Jyoti Nivas College',
  'National College Basavanagudi',
  'Maharani Lakshmi Ammanni College',
  'MES College Bengaluru',
  'Presidency College Bengaluru',
  'NMKRV College for Women',

  // Degree Colleges
  'Alva\'s College Moodbidri',
  'SDM College Ujire',
  'Government First Grade College Karwar',
  'Government First Grade College Bhatkal',
  'Anjuman Degree College Bhatkal',
  'Guru Sudhindra Degree College Bhatkal',
  'Shree Devi Institute of Technology',
  'Canara Engineering College',
  'Sahyadri College of Engineering and Management',
  'Mangalore Institute of Technology and Engineering',
  'St Aloysius College Mangalore',
  'Al Ameen Degree College',
  'KLE Society\'s College'
];
 
export const LANGUAGES_LIST = [
  'English', 'Hindi', 'Kannada', 'Tamil', 'Telugu', 'Malayalam', 'Marathi',
  'Gujarati', 'Bengali', 'Punjabi', 'Urdu', 'Odia', 'Assamese', 'Konkani',
  'Sanskrit', 'French', 'German', 'Spanish', 'Japanese', 'Mandarin Chinese',
  'Arabic', 'Russian', 'Portuguese',
];
 
export const JOB_TITLES_LIST = [
  'Software Engineer', 'Senior Software Engineer', 'Frontend Developer',
  'Backend Developer', 'Full Stack Developer', 'Mobile App Developer',
  'DevOps Engineer', 'Site Reliability Engineer', 'QA Engineer',
  'Data Analyst', 'Data Scientist', 'Data Engineer', 'Machine Learning Engineer',
  'Product Manager', 'Project Manager', 'Business Analyst',
  'UI/UX Designer', 'Graphic Designer', 'Digital Marketing Executive',
  'SEO Specialist', 'Content Writer', 'HR Executive', 'HR Manager',
  'Recruiter', 'Talent Acquisition Specialist', 'Sales Executive',
  'Sales Manager', 'Business Development Executive', 'Customer Support Executive',
  'Accountant', 'Finance Analyst', 'Operations Manager', 'Intern',
  'Trainee Engineer', 'System Administrator', 'Network Engineer',
  'Cloud Engineer', 'Cybersecurity Analyst', 'Technical Lead',
  'Engineering Manager', 'Founder', 'Co-founder',
];
 
export const COMPANIES_LIST = [
  'Tata Consultancy Services (TCS)', 'Infosys', 'Wipro', 'HCLTech',
  'Tech Mahindra', 'Accenture', 'Cognizant', 'Capgemini', 'IBM India',
  'Amazon', 'Google', 'Microsoft', 'Flipkart', 'Swiggy', 'Zomato',
  'Ola', 'Paytm', 'PhonePe', 'Zoho', 'Freshworks', 'Byju\'s', 'Reliance Jio',
  'Larsen & Toubro Infotech (LTIMindtree)', 'Mindtree', 'Mphasis',
  'Persistent Systems', 'Oracle India', 'SAP Labs India', 'Adobe India',
  'Samsung R&D Institute India', 'Deloitte India', 'EY (Ernst & Young)',
  'PwC India', 'KPMG India', 'Bajaj Finserv', 'HDFC Bank', 'ICICI Bank',
  'Axis Bank', 'Startup / Early-stage company', 'Self-employed / Freelance',
];
 
export const CERTIFICATIONS_LIST = [
  'AWS Certified Solutions Architect', 'AWS Certified Developer',
  'AWS Certified Cloud Practitioner', 'Microsoft Certified: Azure Fundamentals',
  'Microsoft Certified: Azure Administrator', 'Google Cloud Professional Data Engineer',
  'Google Cloud Associate Cloud Engineer', 'Certified Kubernetes Administrator (CKA)',
  'Certified ScrumMaster (CSM)', 'PMP - Project Management Professional',
  'Cisco Certified Network Associate (CCNA)', 'CompTIA A+', 'CompTIA Security+',
  'Certified Ethical Hacker (CEH)', 'Oracle Certified Professional Java Programmer',
  'Meta Front-End Developer Certificate', 'Meta Back-End Developer Certificate',
  'IBM Data Science Professional Certificate', 'Google Data Analytics Certificate',
  'Google IT Support Professional Certificate', 'HubSpot Content Marketing Certification',
  'Digital Marketing Certification - Google', 'Salesforce Certified Administrator',
  'Six Sigma Green Belt', 'Six Sigma Black Belt', 'NPTEL Certification',
  'Coursera Course Certificate', 'Udemy Course Certificate',
];
 
export const ISSUERS_LIST = [
  'Amazon Web Services (AWS)', 'Microsoft', 'Google', 'Coursera', 'Udemy',
  'edX', 'NPTEL', 'IBM', 'Meta', 'Cisco', 'CompTIA', 'Oracle', 'Salesforce',
  'HubSpot Academy', 'Project Management Institute (PMI)', 'Scrum Alliance',
  'EC-Council', 'Linux Foundation', 'freeCodeCamp', 'LinkedIn Learning',
  'Great Learning', 'Simplilearn', 'upGrad',
];
 
export const CITIES_LIST = [
  'Bengaluru', 'Mumbai', 'Delhi', 'Hyderabad', 'Chennai', 'Kolkata',
  'Pune', 'Ahmedabad', 'Jaipur', 'Surat', 'Lucknow', 'Kanpur', 'Nagpur',
  'Indore', 'Thane', 'Bhopal', 'Visakhapatnam', 'Patna', 'Vadodara',
  'Ghaziabad', 'Ludhiana', 'Agra', 'Nashik', 'Faridabad', 'Meerut',
  'Rajkot', 'Varanasi', 'Srinagar', 'Amritsar', 'Coimbatore', 'Kochi',
  'Chandigarh', 'Mysuru', 'Mangaluru', 'Noida', 'Gurugram', 'Gurgaon',
];
 
export const STATES_LIST = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
  'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya',
  'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim',
  'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand',
  'West Bengal', 'Delhi (NCT)', 'Jammu and Kashmir', 'Ladakh',
  'Puducherry', 'Chandigarh',
];
 
export const BOARDS_UNIVERSITIES_LIST = [
  'CBSE - Central Board of Secondary Education',
  'ICSE - Indian Certificate of Secondary Education',
  'ISC - Indian School Certificate',
  'State Board', 'NIOS - National Institute of Open Schooling',
  'IB - International Baccalaureate',
  'Anna University', 'Bangalore University', 'Delhi University',
  'Jawaharlal Nehru University', 'Mumbai University', 'Pune University (Savitribai Phule Pune University)',
  'Osmania University', 'Visvesvaraya Technological University (VTU)',
  'Jawaharlal Nehru Technological University (JNTU)',
  'Guru Gobind Singh Indraprastha University (GGSIPU)',
  'Rajiv Gandhi Proudyogiki Vishwavidyalaya (RGPV)',
  'Maulana Abul Kalam Azad University of Technology (MAKAUT)',
  'Karnataka State Open University', 'Indira Gandhi National Open University (IGNOU)',
  'Symbiosis International University', 'Amity University',
  'Vellore Institute of Technology (VIT)', 'Manipal Academy of Higher Education',
  'Birla Institute of Technology and Science (BITS Pilani)',
  'SRM Institute of Science and Technology', 'Lovely Professional University',
  'Chandigarh University', 'Kurukshetra University', 'Panjab University',
  'Andhra University', 'Kerala University', 'Calicut University',
  'Madras University', 'Gujarat Technological University (GTU)',
  'National Institute of Technology (NIT)', 'Indian Institute of Technology (IIT)',
  'University of Mysore',
  'Karnataka University, Dharwad',
  'Mangalore University',
  'Kuvempu University',
  'Gulbarga University',
  'Kannada University, Hampi',
  'Karnataka State Akkamahadevi Women\'s University',
  'Karnataka State Rural Development and Panchayat Raj University',
  'Bengaluru North University',
  'Bengaluru City University',
  'Rani Channamma University, Belagavi',
  'Davangere University',
  'Tumkur University',
  'Vijayanagara Sri Krishnadevaraya University',
  'Maharani Cluster University',
  'Karnatak State Law University',
  'Karnataka Sanskrit University',
  'University of Agricultural Sciences, Bengaluru',
  'University of Agricultural Sciences, Dharwad',
  'University of Horticultural Sciences, Bagalkot',
  'University of Agricultural and Horticultural Sciences, Shivamogga',
  'Karnataka Veterinary, Animal and Fisheries Sciences University (KVAFSU)',
  'Rajiv Gandhi University of Health Sciences (RGUHS)',
  'National Law School of India University (NLSIU)',
  'Indian Institute of Science (IISc)',
  'REVA University',
  'Jain (Deemed-to-be University)',
  'Presidency University, Bengaluru',
  'CMR University',
  'Dayananda Sagar University',
  'Ramaiah University of Applied Sciences',
  'Alliance University',
  'Garden City University',
  'Atria University',
  'Christ (Deemed-to-be University)',
  'Azim Premji University',
  'PES University',
  'KLE Technological University',
  'KLE Academy of Higher Education and Research',
  'BLDE (Deemed-to-be University)',
  'Yenepoya (Deemed-to-be University)',
  'Nitte (Deemed-to-be University)',
  'Sri Siddhartha Academy of Higher Education',
  'M.S. Ramaiah University of Applied Sciences'

];
 
export const DEGREES_LIST = [
  'B.Tech - Computer Science Engineering',
  'B.Tech - Information Technology',
  'B.Tech - Electronics and Communication',
  'B.Tech - Mechanical Engineering',
  'B.Tech - Civil Engineering',
  'B.Tech - Electrical Engineering',
  'B.E. - Computer Science Engineering',
  'BCA - Bachelor of Computer Applications',
  'B.Sc - Computer Science',
  'B.Sc - Information Technology',
  'B.Com',
  'BBA - Bachelor of Business Administration',
  'BA - Bachelor of Arts',
  'M.Tech - Computer Science Engineering',
  'MCA - Master of Computer Applications',
  'M.Sc - Computer Science',
  'MBA - Master of Business Administration',
  'M.Com',
  'MA - Master of Arts',
  'PhD',
  'Diploma in Engineering',
  '12th / Higher Secondary',
  '10th / Secondary School',
];
 
